import { render, staticRenderFns } from "./ReferPopover.vue?vue&type=template&id=50546be1&scoped=true&"
import script from "./ReferPopover.vue?vue&type=script&lang=js&"
export * from "./ReferPopover.vue?vue&type=script&lang=js&"
import style0 from "./ReferPopover.vue?vue&type=style&index=0&id=50546be1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50546be1",
  null
  
)

export default component.exports